import React, { useEffect, useState } from 'react';
import Input from '@amzn/meridian/input';
import { TuningInputProps } from '../model';

/**
 * Numeric headcount input for the Checkout tuning table.
 * The operator enters the target headcount directly; the value is clamped to
 * [0, maxStaffing] on commit so the max staffing constraint can never be exceeded.
 */
const TuningInput: React.FC<TuningInputProps> = ({ value, baseline, maxStaffing, disabled, onChange }) => {
  const [text, setText] = useState<string>(String(value));

  // Keep the local text in sync when the committed value changes externally (e.g. Reset All).
  useEffect(() => {
    setText(String(value));
  }, [value]);

  const commit = (raw: string) => {
    const parsed = parseInt(raw, 10);
    if (isNaN(parsed) || parsed < 0) {
      // Revert invalid input back to the current value.
      setText(String(value));
      onChange(value);
      return;
    }
    const capped = maxStaffing != null ? Math.min(parsed, maxStaffing) : parsed;
    setText(String(capped));
    onChange(capped);
  };

  const isModified = value !== baseline;

  return (
    <div className={`tuned-hc-input ${isModified ? 'tuned-hc-input--modified' : ''}`}>
      <Input
        type="number"
        size="small"
        value={text}
        disabled={disabled}
        onChange={(val: string) => setText(val)}
        onBlur={() => commit(text)}
        aria-label="Tuned headcount"
      />
    </div>
  );
};

export default TuningInput;
